import { useCallback, useState } from "react";
import { cancelTask, resumeTask } from "@/services/api/tasks";

/** Stop / resume handlers for in-flight runner tasks (cancel all tracked IDs; resume root IDs). */
export function useTaskCancelResume(taskIds: string[], rootTaskIds?: string[]) {
  const [cancelRequested, setCancelRequested] = useState(false);
  const [resumeRequested, setResumeRequested] = useState(false);

  const resumeIds = rootTaskIds ?? taskIds;

  const onStop = useCallback(() => {
    if (taskIds.length === 0) return;
    setCancelRequested(true);
    taskIds.forEach((id) => {
      void cancelTask(id);
    });
  }, [taskIds]);

  const onResume = useCallback(async () => {
    if (resumeIds.length === 0) return;
    setResumeRequested(true);
    setCancelRequested(false);
    try {
      await Promise.all(resumeIds.map((id) => resumeTask(id)));
    } finally {
      setResumeRequested(false);
    }
  }, [resumeIds]);

  return { onStop, onResume, cancelRequested, resumeRequested };
}
